// User roles, mirroring the backend `user_role` enum
// (varna-server/src/types/auth-domain.ts). Authority, low → high:
//   user            – end user (mobile app); cannot log into the admin panel
//   safety_manager  – reserved; currently treated like a full admin in the UI
//   user_admin      – LIMITED admin: may manage users only (no documents,
//                     evacuation/safety plans, alarm buttons, facilities…)
//   admin           – full organisation admin
// Superadmin is separate (email allowlist, see constants/superadmin.js).
export const ROLE_ADMIN = "admin";
export const ROLE_SAFETY_MANAGER = "safety_manager";
export const ROLE_USER_ADMIN = "user_admin";
export const ROLE_USER = "user";

// The signed-in user's role is persisted in localStorage.userData at login
// (see hooks/useLogin.ts / useAuthCheck.js). Reading it from there is
// synchronous, so role-gated UI renders without a flash of the wrong state.
export const getStoredRole = () => {
  try {
    const raw = localStorage.getItem("userData");
    return raw ? JSON.parse(raw)?.role ?? null : null;
  } catch {
    return null;
  }
};

// A user_admin is restricted to user management only.
export const isUserAdminRole = (role) => role === ROLE_USER_ADMIN;
